module.exports = __webpack_public_path__ + "img/a_pescado.0f0cb826.svg";